import React from 'react'
import Button from '@active/react-ui/Button'
import Logo from './PageLogo.svg'
import I18nMessage from '../I18nMessage'
import './PageHeader.scss'
import { getUrlParameter } from '../../../shared/utils/commonUtils'

export default function renderPageHeader() {
  const handleBack = () => {
    const returnUrl = getUrlParameter('returnUrl')
    returnUrl && returnUrl !== 'undefined' && window.location.replace(decodeURIComponent(returnUrl))
  }
  return (
    <div className="passport-ui-component__page-header">
      <img src={Logo} className="passport-ui-component__logo" alt="logo" />
      <Button className="back-button" type="primary" size="sm" onClick={handleBack}>
        <i style={{ marginRight: '6px', fontWeight: 600, fontSize: '16px' }} className="ic-angle-left-light" />
        <I18nMessage id="passport.common.btn.back" />
      </Button>
    </div>
  )
}
